import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

import { UiBreakpointsService } from '@ib-core/services/ui-breakpoints.service';
import { UiTouchscreenService } from '@ib-core/services/ui-touchscreen.service';
import { environment } from '@ib-env/environment';
import { AbstractBaseComponent } from '@ib-shared/abstract/abstract-base';
import { PhoneComponent } from '@ib-shared/modules/phone/phone.component';
import { CountriesHttpService } from '@ib-shared/services/countries-data.service';
import { DateTimeFormatService } from '@ib-shared/services/date-time-format.service';
import { PASSWORD_SPECIFIC_SYMBOLS } from '@ib-shared/validation/validators-password';
import { INVESTOR_SIGN_UP_STEPS } from 'credebt-shared';
import * as dayjs from 'dayjs';
import { BehaviorSubject, takeUntil } from 'rxjs';

import { SIGN_UP_FIELDS } from '../../../enums/sign-up-fields.enum';
import { ISignUpStep } from '../../../interfaces/sign-up-step.intf';
import { SignUpFacadeService } from '../../../services/sign-up-facade.service';
import { SignUpFormHelperService } from '../../../services/sign-up-form-facade.service';

@Component({
  selector: 'ib-sign-up-step-start',
  templateUrl: './sign-up-step-start.component.html',
  styleUrls: ['./sign-up-step-start.component.scss'],
})
export class SignUpStepStartComponent
  extends AbstractBaseComponent
  implements OnInit
{
  @Input() form: FormGroup;

  public PASSWORD_SPECIFIC_SYMBOLS = PASSWORD_SPECIFIC_SYMBOLS;
  public showPassw = false;
  public showPasswRepeat = false;
  public maxDate = dayjs().subtract(18, 'years').toDate();
  public phoneDisabled$ = this.facadeS.selectIsPhoneDisabled();
  public readonly SIGN_UP_FIELDS = SIGN_UP_FIELDS;
  public checkEmailLoading$ = this.facadeS.selectIsEmailCheckLoading();
  public checkPhoneLoading$ = this.facadeS.selectIsPhoneCheckLoading();
  public dateFormat$ = this.dateTimeS.selectUiDateFormat();
  public config: ISignUpStep;
  public reinitPhone = true;
  public autodetectedCountryIso$ = new BehaviorSubject<string>(null);
  get phoneFormCtrl(): AbstractControl {
    return this.form.get(SIGN_UP_FIELDS.PHONE);
  }

  @ViewChild('emailInput') emailInput: ElementRef<HTMLInputElement>;
  @ViewChild('phoneInput') phoneInput: PhoneComponent;
  constructor(
    public bpS: UiBreakpointsService,
    public tsS: UiTouchscreenService,
    private dateTimeS: DateTimeFormatService,
    public facadeS: SignUpFacadeService,
    public formS: SignUpFormHelperService,
    private countriesS: CountriesHttpService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.config = this.facadeS.getStepByType(INVESTOR_SIGN_UP_STEPS.START);
    this.initFormFields();
    setTimeout(() => {
      this.emailInput?.nativeElement?.focus();
    }, 500);
    this.countriesS
      .selectUserCountryByIp()
      .pipe(takeUntil(this.destroy$))
      .subscribe(r => {
        this.autodetectedCountryIso$.next(r?.country_code || null);
      });
  }

  submitFromInput(e): void {
    e.stopPropagation();
    e.preventDefault();
    if (this.form.valid) {
      this.facadeS.setNextStep();
    } else {
      this.form.markAllAsTouched();
    }
  }

  editPhoneClicked(): void {
    this.formS.editPhone();
    this.reinitPhone = !this.reinitPhone;
  }

  private initFormFields(): void {
    // mock
    if (!environment.production && environment.allowSignUpUseMocks) {
      this.form
        .get(this.SIGN_UP_FIELDS.EMAIL)
        .setValue(
          `ostashevskiy82+${Math.ceil(Math.random() * 10000)}@gmail.com`,
        );
      this.form.get(this.SIGN_UP_FIELDS.PASSWORD).setValue('Qwerty123!');
      this.form.get(this.SIGN_UP_FIELDS.PASSWORD_REPEAT).setValue('Qwerty123!');
      this.form.get(this.SIGN_UP_FIELDS.FIRST_NAME).setValue('denys');
      this.form.get(this.SIGN_UP_FIELDS.LAST_NAME).setValue('ost!');
      // this.form.get(this.SIGN_UP_FIELDS.LAST_NAME).disable();
      this.form.get(this.SIGN_UP_FIELDS.DOB).setValue(this.maxDate);
      this.form.get(this.SIGN_UP_FIELDS.PHONE).setValue('+380983834484');
      this.form.get(this.SIGN_UP_FIELDS.PHONE_COUNTRY).setValue('ua');
    }
  }
}
